<template>
  <DialogTemplate :show-controls="false" class="dialog">
    <div v-if="feedStore.totalCount > 0" class="feed-wrapper">
      <ul class="scrollable">
        <FeedView />
      </ul>
    </div>
    <FeedBlockEmpty v-else />
  </DialogTemplate>
</template>
<script setup lang="ts">
const feedStore = useFeedStore();
</script>
<style lang="scss" scoped>
.dialog {
  padding: var(--gap_m) var(--stroke_thickness_m);
}
.feed-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  max-height: calc(
    100dvh - var(--header_height) - var(--footer_height) - var(--row_gap) -
      var(--row_gap) - var(--row_gap)
  );
  padding: 0;
  gap: 1rem;

  .scrollable {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 var(--gap_n) 0 var(--gap_n);
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color_secondary_lighter);
    }

    &::-webkit-scrollbar-track {
      background: var(--color_neutral_25);
    }
  }
}
</style>
